"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_facebook_login_1 = __importDefault(require("@greatsumini/react-facebook-login"));
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var socialAuthApi_1 = __importDefault(require("../../../api/socialAuthApi"));
var appConfig_1 = __importDefault(require("../../../config/appConfig"));
var SocialLoginPanel_module_scss_1 = __importDefault(require("./SocialLoginPanel.module.scss"));
var FacebookAuthButton = function (_a) {
    var onAuthenticated = _a.onAuthenticated, onError = _a.onError, onLoadingChange = _a.onLoadingChange;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(false), isSubmitting = _b[0], setIsSubmitting = _b[1];
    var facebookAppId = (0, react_1.useMemo)(function () { return appConfig_1.default.getFacebookAppId(); }, []);
    var setLoading = function (loading) {
        setIsSubmitting(loading);
        onLoadingChange === null || onLoadingChange === void 0 ? void 0 : onLoadingChange(loading);
    };
    var handleSuccess = function (response) { return __awaiter(void 0, void 0, void 0, function () {
        var verifiedLogin, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!response.accessToken) {
                        onError(t("FACEBOOK_AUTH_ERROR_NO_ACCESS_TOKEN"));
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, socialAuthApi_1.default.startFacebookOAuthLogin({
                            access_token: response.accessToken
                        })];
                case 2:
                    verifiedLogin = _a.sent();
                    onAuthenticated({
                        user: {
                            id: verifiedLogin.user.id,
                            email: verifiedLogin.user.email,
                            name: verifiedLogin.user.name || "Facebook User"
                        },
                        session_id: verifiedLogin.session_id,
                        access_token: verifiedLogin.access_token
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _a.sent();
                    onError(error_1 instanceof Error
                        ? error_1.message
                        : t("FACEBOOK_AUTH_ERROR_LOGIN_FAILED"));
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var button = function (onClick, disabled) {
        if (disabled === void 0) { disabled = false; }
        return ((0, jsx_runtime_1.jsxs)("button", { type: "button", className: "".concat(SocialLoginPanel_module_scss_1.default.loginButton, " ").concat(SocialLoginPanel_module_scss_1.default.googleButton, " ").concat(SocialLoginPanel_module_scss_1.default.facebookButton), disabled: disabled || isSubmitting, onClick: onClick, children: [(0, jsx_runtime_1.jsx)("span", { className: "".concat(SocialLoginPanel_module_scss_1.default.googleIconBox, " ").concat(SocialLoginPanel_module_scss_1.default.facebookIconBox), "aria-hidden": "true", children: "f" }), (0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.googleButtonLabel, children: t("FACEBOOK_AUTH_BUTTON_LABEL") })] }));
    };
    if (!facebookAppId) {
        return ((0, jsx_runtime_1.jsx)("div", { className: SocialLoginPanel_module_scss_1.default.googleLoginWrapper, children: button(undefined, true) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: SocialLoginPanel_module_scss_1.default.googleLoginWrapper, children: [(0, jsx_runtime_1.jsx)(react_facebook_login_1.default, { appId: facebookAppId, scope: "public_profile,email", onSuccess: handleSuccess, onFail: function () { return onError(t("FACEBOOK_AUTH_ERROR_POPUP_BLOCKED")); }, render: function (_a) {
                    var onClick = _a.onClick;
                    return button(onClick);
                } }), isSubmitting ? ((0, jsx_runtime_1.jsx)("p", { className: SocialLoginPanel_module_scss_1.default.googleHintText, children: t("FACEBOOK_AUTH_HINT_VERIFYING") })) : null] }));
};
exports.default = FacebookAuthButton;
